import React from 'react';
import { ISearchInput } from 'src/pages/CatalogPage/CatalogPage.i';
import { ClearFilters } from 'src/pages/CatalogPage/components/FilterMenu/ClearFilters/ClearFilters';
import { ISessionMapping } from 'src/pages/CatalogPage/Catalog.i';

import { FiltersSetDialogStyles } from 'src/pages/CatalogPage/components/FiltersSetDialog/FiltersSetDialog.style';

interface IFiltersSetDialog {
  searchInput: ISearchInput;
  searchName: string;
  sessions: ISessionMapping[];
  searchBusy: boolean;
}

export const FiltersSetDialog = (props: IFiltersSetDialog) => {
  const { keywords, amcode, hlo, manu, caliber, subcaliber, session } = props.searchInput;

  const appliedFilters = [];
  if(hlo.length > 0) {
    const HLOs = {
      H: 'Handgun',
      L: 'Long Gun',
      O: 'Other',
    };
    const HLO = hlo.length === 1 ? HLOs[hlo] : hlo;
    appliedFilters.push(HLO);
  }
  if(manu.length > 0) {
    appliedFilters.push(manu);
  }
  if(caliber.length > 0) {
    appliedFilters.push(caliber);
  }
  if(subcaliber.length > 0) {
    appliedFilters.push(subcaliber);
  }
  if(session.length > 0) {
    const sess = props.sessions.filter((s) => s.value == session)[0];
    const formattedDay = sess ? sess.name : '';
    appliedFilters.push(formattedDay);
  }
  if(amcode.length > 0) {
    const catFilters = {
      A: 'Antique Firearms',
      AL: 'Antique Lots',
      C: 'Curio & Relic',
      I: 'Class III',
      M: 'Modern Firearms',
    };
    appliedFilters.push(catFilters[amcode]);
  }
  if(!props.searchName && !(appliedFilters.length > 0) && !(keywords.length > 0)) {
    return null;
  }
  return (
    <FiltersSetDialogStyles>
      <div>
        <div>
          {keywords.length > 0 && ( props.searchBusy ? <div>Searching for: {keywords}...</div> : <div>Searched for: {keywords}</div>)}
          {appliedFilters.length > 0 && <div>Applied Filter: {appliedFilters.join(', ')}</div>}
          {props.searchName && <div>Collection: {props.searchName}</div>}
        </div>
        <ClearFilters searchInput={props.searchInput} />
      </div>
    </FiltersSetDialogStyles>
  );
};
